import { Link } from 'react-router-dom';

const SOLUTIONS = [
  { label: 'Professional Websites', href: '/solutions/professional-websites' },
  { label: 'Customer Communication', href: '/solutions/customer-communication' },
  { label: 'Appointment Coordination', href: '/solutions/appointment-coordination' },
  { label: 'Business Workflow Support', href: '/solutions/business-workflow' },
  { label: 'Lead Qualification', href: '/solutions/lead-qualification' },
  { label: 'Internal Organization', href: '/solutions/internal-organization' },
];

const SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/7thvision_?stkn=MXE4bjlvNG83bHE1Ng%3D%3D&utm_source=qr',
  },
  {
    label: 'Facebook',
    href: 'https://m.facebook.com/profile.php?id=1186560214540202&ref=pl_edit_xav_ig_profile_page&target=1186560214540202&wtsid=rdr_03uWWPJxkuWxd31ZU&hr=1',
  },
];

export default function Footer() {
  return (
    <footer className="bg-stone-900 text-stone-400">
      <div className="section-padding py-10 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          {/* Brand */}
          <div>
            <p className="font-serif text-2xl text-stone-100 mb-4">
              7th <span className="font-semibold text-bronze-500">Vision</span>
            </p>
            <div className="w-10 h-px bg-bronze-500 mb-6" />
            <p className="text-sm leading-relaxed text-stone-500">
              Website design and customer communication solutions for established businesses.
            </p>
          </div>

          {/* Solutions */}
          <div>
            <p className="text-xs tracking-widest uppercase text-stone-500 mb-6">Solutions</p>
            <ul className="space-y-3">
              {SOLUTIONS.map((s) => (
                <li key={s.href}>
                  <Link
                    to={s.href}
                    className="text-sm text-stone-400 hover:text-stone-200 transition-colors duration-300"
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-xs tracking-widest uppercase text-stone-500 mb-6">Company</p>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-stone-400 hover:text-stone-200 transition-colors duration-300">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-stone-400 hover:text-stone-200 transition-colors duration-300">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-stone-400 hover:text-stone-200 transition-colors duration-300">
                  Schedule a Conversation
                </Link>
              </li>
            </ul>
            <div className="mt-8">
              <p className="text-xs tracking-widest uppercase text-stone-500 mb-4">Social</p>
              <ul className="flex flex-wrap gap-x-5 gap-y-3">
                {SOCIAL_LINKS.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-stone-400 hover:text-stone-200 transition-colors duration-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-20 pt-8 border-t border-stone-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-stone-600">
            &copy; {new Date().getFullYear()} 7th Vision. All rights reserved.
          </p>
          <p className="text-xs text-stone-600">
            Professional websites. Reliable communication. Thoughtful execution.
          </p>
        </div>
      </div>
    </footer>
  );
}
